import { render, staticRenderFns } from "./reportCustomManageList.vue?vue&type=template&id=2b2f5d6c&scoped=true"
import script from "./reportCustomManageList.vue?vue&type=script&lang=js"
export * from "./reportCustomManageList.vue?vue&type=script&lang=js"
import style0 from "./reportCustomManageList.vue?vue&type=style&index=0&id=2b2f5d6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b2f5d6c",
  null
  
)

export default component.exports